import api from '../api'
import type { UserMonitoringResponse } from './types'

export const MonitoringV2Service = {
  fetchUserMonitoring() {
    return api.get<UserMonitoringResponse[]>('/v2/mon/')
  },
  deleteUserMonitoring(rowId: number) {
    return api.delete(`/v2/mon/${rowId}`)
  },
  saveUserMonitoring(
    exBuy: string,
    exSell: string,
    asset: string,
    spread: number | null,
    backspread: number | null,
    isSpot: boolean,
  ) {
    return api.put('/v2/mon/', {
      ex_buy: exBuy,
      ex_sell: exSell,
      asset: asset,
      spread: spread,
      backspread: backspread,
      is_spot: isSpot,
    })
  },
}
